import styled from '@emotion/styled';

const SettingsRoot = styled.div`
  grid-column: 1 / -1;
  grid-row: 2 / -1;
  min-height: 0;
  overflow: auto;
`;

export default { SettingsRoot };
